module.exports = __webpack_public_path__ + "static/media/human-contacts.4b9bae42.svg";